import { render, staticRenderFns } from "./tree-template.vue?vue&type=template&id=0b67eaca&"
import script from "./tree-template.vue?vue&type=script&lang=js&"
export * from "./tree-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports